import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "not-found" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Button = _resolveComponent("Button")
  const _component_Empty = _resolveComponent("Empty")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Empty, {
      bordered: false,
      class: "empty",
      "bg-size": "36rem",
      "circle-size": "7.6rem"
    }, _createSlots({
      image: _withCtx(() => [
        _createVNode(_component_Icon, {
          stroke: "var(--brand-500)",
          size: "2.8rem",
          icon: "activity"
        })
      ]),
      _: 2 /* DYNAMIC */
    }, [
      ($props.filters)
        ? {
            name: "title",
            fn: _withCtx(() => [
              _createTextVNode(" No " + _toDisplayString($props.itemsName) + " found ", 1 /* TEXT */)
            ]),
            key: "0"
          }
        : {
            name: "title",
            fn: _withCtx(() => [
              _createTextVNode(" There are no " + _toDisplayString($props.itemsName) + " yet ", 1 /* TEXT */)
            ]),
            key: "1"
          },
      ($props.filters)
        ? {
            name: "sub-text",
            fn: _withCtx(() => [
              _createTextVNode(" There are no " + _toDisplayString($props.itemsName) + " matching your criteria ", 1 /* TEXT */)
            ]),
            key: "2"
          }
        : {
            name: "sub-text",
            fn: _withCtx(() => [
              _cache[4] || (_cache[4] = _createTextVNode(" Create your first tracker "))
            ]),
            key: "3"
          },
      ($props.filters)
        ? {
            name: "link",
            fn: _withCtx(() => [
              _cache[5] || (_cache[5] = _createTextVNode(" You might want to clear the filters "))
            ]),
            key: "4"
          }
        : undefined,
      ($props.filters)
        ? {
            name: "actions",
            fn: _withCtx(() => [
              _createVNode(_component_Button, {
                class: "clear",
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('clear')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Icon, {
                    icon: "filter-x",
                    size: "1.6rem",
                    "stroke-width": "1",
                    stroke: "var(--brand-700)"
                  }),
                  _cache[6] || (_cache[6] = _createTextVNode(" Clear filters "))
                ]),
                _: 1 /* STABLE */
              })
            ]),
            key: "5"
          }
        : {
            name: "actions",
            fn: _withCtx(() => [
              _createVNode(_component_Button, {
                class: "track",
                primary: "",
                onClick: _cache[1] || (_cache[1] = $event => (_ctx.$dispatch('track-company')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Icon, {
                    icon: "building-02",
                    size: "1.6rem",
                    "stroke-width": "1",
                    stroke: "var(--brand-50)"
                  }),
                  _cache[7] || (_cache[7] = _createTextVNode(" Track a company "))
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_Button, {
                class: "track",
                primary: "",
                onClick: _cache[2] || (_cache[2] = $event => (_ctx.$dispatch('track-person')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Icon, {
                    icon: "user-03",
                    size: "1.6rem",
                    "stroke-width": "1",
                    stroke: "var(--brand-50)"
                  }),
                  _cache[8] || (_cache[8] = _createTextVNode(" Track a person "))
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_Button, {
                class: "track",
                primary: "",
                onClick: _cache[3] || (_cache[3] = $event => (_ctx.$dispatch('track-topic')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Icon, {
                    icon: "hash-02-a",
                    size: "1.6rem",
                    "stroke-width": "1",
                    stroke: "var(--brand-50)"
                  }),
                  _cache[9] || (_cache[9] = _createTextVNode(" Track a topic "))
                ]),
                _: 1 /* STABLE */
              })
            ]),
            key: "6"
          }
    ]), 1024 /* DYNAMIC_SLOTS */)
  ]))
}